import { useEffect } from "react";
import { diffChars, Change } from "diff";
import usePrevious from "./contents/underlines/hooks/usePrevious";

export function isValue(c: Change): boolean {
  return c.added === undefined && c.removed === undefined;
}

export default function useOnTextEdit(
  text: string,
  onTextEdit: (edits: Change[]) => void,
  deps: unknown[]
): void {
  const previousText = usePrevious(text);
  useEffect(() => {
    if (!previousText) {
      return;
    }
    const edits = diffChars(previousText, text);

    // we don't need to update if there's no diff
    if (edits.length === 1 && isValue(edits[0])) {
      return;
    }

    onTextEdit(edits);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, previousText, onTextEdit, ...deps]);
}
